const parseQueryString = (queryString) => {
  let urlParams = {};
  if (queryString.charAt(0) === '?') {
    queryString = queryString.substring(1);
  } else if (queryString === '') {
    return urlParams;
  }
  const pl = /\+/g; // Regex for replacing addition symbol with a space
  let search = /([^&=]+)=?([^&]*)/g;
  const decode = (s) => {
    return decodeURIComponent(s.replace(pl, ' '));
  };
  let match;
  while ((match = search.exec(queryString))) {
    urlParams[decode(match[1])] = decode(match[2]);
  }
  return urlParams;
};

class NutsToolOrigin {
  constructor (params) {
    console.log('NutsToolOrigin: Initialize');
    params = params || {};
    this.__location = params.location || window.location;
    this.__source = params.source;
    this.__onReady = params.onReady || function () {};
    this.__onErr = params.onErr || function () {};
    this.init();
    return this;
  }
  /**
   * initialize app
   * @return {void}
   */
  async init () {
    const locationData = this.__location;
    const cookie = this.read('NUTSBP_ORIGIN');
    const userPath = cookie.entry_pages || [];
    const url = document.referrer;
    userPath.push(locationData.href);

    // Record utm
    const queryString = parseQueryString(locationData.search);

    let origin = {};
    if (this.__source === 'saishi') {
      origin.utm_source = this.__source;
    } else {
      if (queryString.utm_source) origin.utm_source = queryString.utm_source;
    }
    if (queryString.utm_medium) origin.utm_medium = queryString.utm_medium;
    if (queryString.utm_campaign) origin.utm_campaign = queryString.utm_campaign;
    if (queryString.utm_content) origin.utm_content = queryString.utm_content;
    if (queryString.utm_term) origin.utm_term = queryString.utm_term;

    // Record invisted path
    if (!url.match(/nutsbp.com/g) && url !== '') {
      console.log('NutsToolOrigin: Start record user from');
      origin.entry_pages = userPath;
      try {
        const result = await this.loadConfig();
        const link = document.createElement('a');
        origin.origin_url = url;
        origin.origin_host = link.hostname;
        origin.search_word = queryString.utm_term || '';
        if (result[link.hostname]) {
          origin.search_word = queryString[result[link.hostname].key];
        }

        this.write('NUTSBP_ORIGIN', origin, 15);
        link.remove();
        this.__onReady(origin);
        console.log('NutsToolOrigin: Write original information in cookie and ready!');
      } catch (err) {
        console.error(err);
      }
    } else {
      this.__onReady(origin);
    }
  }
  /**
   * Load searchKey configuration from server
   * The searchKey is used to define the key word for search
   * @return {promise} ajax promise
   */
  loadConfig () {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      let method = 'GET';
      let url = `//static.thomas.nutsbp.com/nutsbp-config/searchKey.json`;
      xhr.open(method, url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
          try {
            let json = JSON.parse(xhr.responseText);
            resolve(json);
          } catch (e) {
            reject(e);
          }
        }
      };
      xhr.onerror = function (e) {
        reject(e);
      };
      xhr.send();
    });
  }
  /**
   * read cookie data
   * @param  {String} key The name of cookie data
   * @return {Object} The cookie data
   */
  read (key) {
    const arr = document.cookie.match(new RegExp('(^| )' + key + '=([^;]*)(;|$)'));
    let data = {};
    if (arr != null) {
      data = JSON.parse(unescape(arr[2]));
    }
    return data;
  }
  /**
   * write data to cookie
   * @param  {String} key       The name of cookie data
   * @param  {Object} data      The data of cookie
   * @param  {Number} expireDay The expire day
   * @return {Object} The new cookie data
   */
  write (key, data, expireDay) {
    let expires = expireDay || '';
    if (expireDay) {
      const nowDay = new Date();
      nowDay.setTime(nowDay.getTime() + (expireDay * 24 * 60 * 60 * 1000));
      expires = `expires=${nowDay.toGMTString()}`;
    }

    var cookie = this.read(key);
    cookie = Object.assign(cookie, data);
    document.cookie = `${key}=${JSON.stringify(cookie)}; ${expires}; domain=nutsbp.com; path=/`;
    document.cookie = `${key}=${JSON.stringify(cookie)}; ${expires}; domain=localhost; path=/`;
    return cookie;
  }
}

export default NutsToolOrigin;



// WEBPACK FOOTER //
// ./src/index.js